import { render, staticRenderFns } from "./advertUpdate.vue?vue&type=template&id=3b98e524&scoped=true"
import script from "./advertUpdate.vue?vue&type=script&lang=js"
export * from "./advertUpdate.vue?vue&type=script&lang=js"
import style0 from "./advertUpdate.vue?vue&type=style&index=0&id=3b98e524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b98e524",
  null
  
)

export default component.exports